<div id="student-profile-view-popup-top" class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 1607px;"></div>
  <div class="modal-dialog" style="width:68%">
    <div class="modal-content" style="border-radius: 7px;">
      <div class="modal-header" style="color:white;line-height: 0.5;border-bottom: 1px solid var(--brand-primary-color);background: var(--brand-primary-color);border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
        <div class="modal-title" style="font-weight: 500">
          <span style="margin-left: 10px;text-transform: capitalize;"><b>{{studentName}}</b>{{ 'sProfile' | translate }}</span>
          &nbsp;&nbsp;&nbsp;<i id="print-student-profile-form" class="md md-print cursor-pointer"></i>
        </div>
      </div>
      <div class="modal-body" id="student-profile-print-container">
        <div *ngIf="profileIsLoading" class="center">
          <i class="fa fa-spinner fa-spin" aria-hidden="true" style="vertical-align: middle"></i>
        </div>
        <div *ngIf="!profileIsLoading" style="border: dashed 2px grey">
          <div class="row">
            <div class="center">
              <h3>{{studentProfile.schoolName}}</h3>
              <h5>{{studentProfile.schoolAddress}}</h5>
            </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class=" center">
							<span class="profile-picture">
								<img style="width: 150px;height: 150px" class="editable img-responsive" alt=" Avatar" id="avatar2" src="{{studentProfile.studentImage}}">
							<!--<span>{{studentProfile.studentName}}</span>-->
              </span>
            </div><!-- /.col -->

            <!-- Basic details -->
            <div style="bottom: 13px;margin-left: 8%">
              <h4 class="black" style="font-weight: bolder">
                <span class="middle">{{ 'personalDetails' | translate }}: </span>
              </h4>

              <div>
                <table class="table table-striped" style="width: 90%">
                  <tr>
                    <th>{{ 'studentName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.studentName}}</td>

                    <th>{{ 'surname' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.surname || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'fatherName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.parentName}}</td>

                    <th>{{ 'motherName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.motherName || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'mobileNumber' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.mobileNumber}}</td>

                    <th>{{ 'houseName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.houseName || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'dateOfBirth' | translate }}</th>
                    <td>:</td>
                    <td>{{formatDate(studentProfile.dateOfBirth)}}</td>

                    <th>{{ 'gender' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.gender || '-'}}</td>
                  </tr>
                  <tr>
                    <th>{{ 'address' | translate }}</th>
                    <td>:</td>
                    <td colspan="4">{{studentProfile.address || '-'}}</td>
                  </tr>
                </table>
              </div>

            </div><!-- /.col -->

            <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <!-- Academic details -->
            <div style="margin-left: 8%">
              <h4 class="black" style="font-weight: bolder">
                <span class="middle">{{ 'academicDetails' | translate }}: </span>
              </h4>

              <div>
                <table class="table table-striped" style="width: 90%">
                  <tr>
                    <th>{{ 'academicYear' | translate }}</th>
                    <td>:</td>
                    <td>{{academicInfo.academicYear}}</td>

                    <th>{{ 'busName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.BusName || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'admissionDate' | translate }}</th>
                    <td>:</td>
                    <td>{{formatDate(studentProfile.dateOfAdmission)}}</td>

                    <th>{{ 'busNumber' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.BusNumber || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'admissionNumber' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.registrationId || '-'}}</td>

                    <th>{{ 'busStopName' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.BusStopName || '-'}}</td>
                  </tr>

                  <tr>
                    <th>{{ 'className' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.className}}</td>

                    <th>{{ 'busRoute' | translate }}</th>
                    <td>:</td>
                    <td>{{studentProfile.BusRoute || '-'}}</td>
                  </tr>
                  <tr>
                    <th>{{ 'rollNumber' | translate }}</th>
                    <td>:</td>
                    <td colspan="4">{{studentProfile.rollNumber || '-'}}</td>
                  </tr>
                  <tr>
                    <th>{{ 'admittedClass' | translate }}</th>
                    <td>:</td>
                    <td colspan="4">{{studentProfile.admittedClass}}</td>
                  </tr>
                  <tr>
                    <th>{{ 'admittedAcademic' | translate }}</th>
                    <td>:</td>
                    <td colspan="4">{{studentProfile.admittedAcademic}}</td>
                  </tr>
                </table>
              </div>

            </div><!-- /.col -->
          </div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</div>
